"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-time.tsx
var Time = function Time(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M25.4999 27.8335L27.8333 25.5002L21.6666 19.3335V11.6668H18.3333V20.6668L25.4999 27.8335ZM19.9999 36.6668C17.6944 36.6668 15.5277 36.2293 13.4999 35.3543C11.4721 34.4793 9.70825 33.2918 8.20825 31.7918C6.70825 30.2918 5.52075 28.5279 4.64575 26.5002C3.77075 24.4724 3.33325 22.3057 3.33325 20.0002C3.33325 17.6946 3.77075 15.5279 4.64575 13.5002C5.52075 11.4724 6.70825 9.7085 8.20825 8.2085C9.70825 6.7085 11.4721 5.521 13.4999 4.646C15.5277 3.771 17.6944 3.3335 19.9999 3.3335C22.3055 3.3335 24.4721 3.771 26.4999 4.646C28.5277 5.521 30.2916 6.7085 31.7916 8.2085C33.2916 9.7085 34.4791 11.4724 35.3541 13.5002C36.2291 15.5279 36.6666 17.6946 36.6666 20.0002C36.6666 22.3057 36.2291 24.4724 35.3541 26.5002C34.4791 28.5279 33.2916 30.2918 31.7916 31.7918C30.2916 33.2918 28.5277 34.4793 26.4999 35.3543C24.4721 36.2293 22.3055 36.6668 19.9999 36.6668ZM19.9999 33.3335C23.6944 33.3335 26.8402 32.0349 29.4374 29.4377C32.0346 26.8404 33.3333 23.6946 33.3333 20.0002C33.3333 16.3057 32.0346 13.1599 29.4374 10.5627C26.8402 7.96544 23.6944 6.66683 19.9999 6.66683C16.3055 6.66683 13.1596 7.96544 10.5624 10.5627C7.9652 13.1599 6.66658 16.3057 6.66658 20.0002C6.66658 23.6946 7.9652 26.8404 10.5624 29.4377C13.1596 32.0349 16.3055 33.3335 19.9999 33.3335Z",
    fill: "currentColor"
  }));
};

var _default = Time;
exports.default = _default;